import * as React from 'react';
import { Form, Input, Label } from 'semantic-ui-react';

interface Props {
    input: {
        value: any;
        onChange: any;
        type?: string;
    };
    label?: string;
    options?: React.ReactNode;
    meta: {
        touched?: boolean;
        error?: string;
    };
    nullOnUnmount?: boolean;
    name: string;
    step?: string;
    inputProps?: Record<string, string>;
}

export class RenderField extends React.PureComponent<Props> {
    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        nullOnUnmount: true
    };

    componentWillUnmount(): void {
        const { input, nullOnUnmount } = this.props;
        if (nullOnUnmount) {
            input.onChange(null);
        }
    }

    render(): React.ReactElement {
        const {
            input: { value = '', ...input },
            label,
            meta: { touched, error },
            options,
            nullOnUnmount,
            name,
            inputProps,
            ...props
        } = this.props;

        // to solve decimal input issue on some Apple browsers
        if (input.type === 'number' && !props.step) {
            props.step = 'any';
        }

        const inputComponent = inputProps ? (
            <Input value={value} {...input} {...props}>
                <input {...inputProps} />
            </Input>
        ) : (
            <Input value={value} {...input} {...props} />
        );

        return (
            <Form.Field
                style={{ position: 'relative' }}
                error={!!(touched && error)}
            >
                {label && <label htmlFor={name}>{label}</label>}
                {options}
                {inputComponent}
                {!!(touched && error) && (
                    <Label basic color="red" pointing>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}

export default RenderField;
